import React from "react";

export default function MySQL_SUBSTRING_INDEX() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUBSTRING_INDEX</h1>
      <p>This is the MySQL_SUBSTRING_INDEX component generated from the SQL JSON.</p>
    </div>
  );
}
